var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    [
      !_vm.userLogin()
        ? [
            _c(
              "div",
              {
                staticClass:
                  "card w-50 mx-auto p-5 d-flex align-items-center rounded shadow",
                attrs: { id: "main-card" }
              },
              [
                _vm._m(0),
                _vm._v(" "),
                _c(
                  "div",
                  {
                    staticClass: "mx-auto w-100",
                    attrs: { id: "card-inner-container" }
                  },
                  [
                    _vm._m(1),
                    _vm._v(" "),
                    _vm._m(2),
                    _vm._v(" "),
                    _vm._m(3),
                    _vm._v(" "),
                    _c(
                      "div",
                      { staticClass: "row justify-content-md-center" },
                      [
                        _c(
                          "div",
                          {
                            staticClass:
                              "col-12 col-lg-10 mt-4 mx-auto text-center"
                          },
                          [
                            _c(
                              "button",
                              {
                                staticClass: "btn btn-primary",
                                attrs: { type: "button" },
                                on: {
                                  click: function($event) {
                                    $event.preventDefault()
                                    return _vm.$router.push({ path: "/" })
                                  }
                                }
                              },
                              [_vm._v("Login")]
                            )
                          ]
                        )
                      ]
                    )
                  ]
                )
              ]
            )
          ]
        : [
            _c("main-header", {
              attrs: { userProfileData: _vm.userProfileData }
            }),
            _vm._v(" "),
            _vm._m(4)
          ]
    ],
    2
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "container h-100" }, [
      _c("div", { staticClass: "row justify-content-md-center" }, [
        _c("div", { staticClass: "col-12 mx-auto" }, [
          _c("img", {
            attrs: {
              id: "qrp-logo",
              src: require("../../assets/qrp-rtm-color.svg"),
              alt: "QuinStreet Rating Platform",
              width: "150px",
              height: "auto"
            }
          })
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-md-center" }, [
      _c(
        "div",
        { staticClass: "col-12 col-lg-10 mt-5 mx-auto unlink page-404-color" },
        [_c("span", { staticClass: "fas fa-unlink fa-7x" })]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-md-center" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 col-lg-10 mt-3 mx-auto text-center page-404-color"
        },
        [
          _c("div", { staticClass: "text-404-head" }, [
            _vm._v("404 Page Not Found")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row justify-content-md-center" }, [
      _c(
        "div",
        {
          staticClass:
            "col-12 col-lg-10 mt-1 mx-auto text-center page-404-color"
        },
        [
          _c("div", { staticClass: "text-404-label" }, [
            _vm._v("We're sorry. It looks like this page does not exist.")
          ])
        ]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "main" }, [
      _c("div", { staticClass: "container-fluid w-100" }, [
        _c("div", { staticClass: "row justify-content-md-center" }, [
          _c(
            "div",
            {
              staticClass: "col-12 col-lg-10 mt-5 mx-auto unlink page-404-color"
            },
            [_c("span", { staticClass: "fas fa-unlink fa-7x" })]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-md-center" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-lg-10 mt-3 mx-auto text-center page-404-color"
            },
            [
              _c("div", { staticClass: "text-404-head" }, [
                _vm._v("404 Page Not Found")
              ])
            ]
          )
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "row justify-content-md-center" }, [
          _c(
            "div",
            {
              staticClass:
                "col-12 col-lg-10 mt-1 mx-auto text-center page-404-color"
            },
            [
              _c("div", { staticClass: "text-404-label" }, [
                _vm._v("We're sorry. It looks like this page does not exist.")
              ])
            ]
          )
        ])
      ])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-b14a6bc6", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-b14a6bc6","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0&bustCache!./src/components/interview/NotFound.vue
// module id = null
// module chunks = 